import { useCallback } from 'react';
import { candidatesService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Candidate } from '../types';

export function useCandidates(
  options?: ResourceQueryOptions
): ResourceState<Candidate> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      candidatesService.getAll(opts) as unknown as Promise<{ data: Candidate[]; meta?: any }>,
    []
  );
  return useResourceCollection<Candidate>(fetchFn, options);
}

export function useCandidate(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Candidate> {
  const resourceId = id;
  const fetchFn = useCallback(
    (candidateId: string | number, opts?: ResourceQueryOptions) =>
      candidatesService.getById(candidateId, opts) as unknown as Promise<Candidate>,
    []
  );
  return useResourceById<Candidate>(fetchFn, resourceId, options);
}

export function useCreateCandidate(
  onSuccess?: (data: Candidate) => void
): MutationState<Candidate> {
  const createFn = useCallback(
    (data: any) => candidatesService.create(data) as unknown as Promise<Candidate>,
    []
  );
  return useCreateResource<Candidate>(createFn, onSuccess);
}

export function useUpdateCandidate(
  onSuccess?: (data: Candidate) => void
): MutationState<Candidate> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return candidatesService.update(id, data) as unknown as Promise<Candidate>;
    },
    []
  );
  return useUpdateResource<Candidate>(updateFn, onSuccess);
}

/**
 * Delete candidate using documentId
 * @param data - Full candidate object containing documentId
 */
export function useDeleteCandidate(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return candidatesService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
